import React from 'react';

import { CoreIcon } from '@aspid/ui';

import { IconCollection } from '@components/icons/iconCollection';

import type { DownloadIconProperties } from './DownloadIcon.types';

export const DownloadIcon: React.FC<DownloadIconProperties> = ({
  dataTest = 'download_icon',
  onClick,
  sx,
  disabled,
}) => {
  const handleClick = React.useCallback(
    (event: React.MouseEvent<SVGSVGElement>) => {
      event.preventDefault();
      onClick?.(event);
    },
    [onClick],
  );

  return (
    <CoreIcon
      dataTest={dataTest}
      icon={IconCollection.downloadFileThin}
      onClick={handleClick}
      sx={sx}
      isDisabled={disabled}
    />
  );
};
